export default "__VITE_ASSET__CzKILom6__"